import { gql } from "@apollo/client";

export default gql`
  fragment TagFragment on tags {
    id
    name
    isCompulsory
  }
`;
